import { POSTER_SIZES } from '@/types/canvas';

interface SizeIndicatorsProps {
  width: number;
  height: number;
  posterSize: string;
  orientation: 'portrait' | 'landscape';
}

export function SizeIndicators({ width, height, posterSize, orientation }: SizeIndicatorsProps) {
  const size = POSTER_SIZES[posterSize as keyof typeof POSTER_SIZES];
  const actualWidth = orientation === 'portrait' ? size.width : size.height;
  const actualHeight = orientation === 'portrait' ? size.height : size.width;

  const indicatorOffset = 30; // Mírně větší odstup od plakátu
  const arrowSize = 5; // Velikost šipky
  const fontSize = 12;
  const lineColor = '#333'; // Tmavší barva čar pro lepší viditelnost
  const textColor = '#000'; // Černá barva textu pro lepší kontrast

  return (
    <>
      {/* Horizontální čára (šířka) - podle předlohy nad posterem */}
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: `${-indicatorOffset}px`, // Konzistentní vzdálenost od plakátu
          width: `${width}px`,
          height: '1px',
          pointerEvents: 'none',
          zIndex: 20, // Zajistit, že je nad ostatními elementy
        }}
      >
        <svg width={width} height={arrowSize * 2} style={{ position: 'absolute', top: `-${arrowSize}px`, left: '0' }}>
          {/* Hlavní čára po celé šířce */}
          <line x1="0" y1={arrowSize} x2={width} y2={arrowSize} stroke={lineColor} strokeWidth="1" />
          {/* Levá šipka */}
          <polyline points={`${arrowSize},${arrowSize - arrowSize/2} 0,${arrowSize} ${arrowSize},${arrowSize + arrowSize/2}`} stroke={lineColor} strokeWidth="1" fill="none" />
          {/* Pravá šipka */}
          <polyline points={`${width - arrowSize},${arrowSize - arrowSize/2} ${width},${arrowSize} ${width - arrowSize},${arrowSize + arrowSize/2}`} stroke={lineColor} strokeWidth="1" fill="none" />
        </svg>
        {/* Text uprostřed */}
        <span
          style={{
            position: 'absolute',
            left: '50%',
            top: `-${arrowSize * 2 + 5}px`, // Menší prostor nad čarou
            transform: 'translateX(-50%)',
            fontSize: `${fontSize}px`,
            fontFamily: 'monospace',
            color: textColor,
            whiteSpace: 'nowrap',
            fontWeight: 'bold',
            backgroundColor: 'rgba(255, 255, 255, 0.8)', // Bílé pozadí pro lepší čitelnost
            padding: '2px 4px',
            borderRadius: '2px',
          }}
        >
          {actualWidth}mm
        </span>
      </div>

      {/* Vertikální čára (výška) - podle předlohy vlevo od posteru */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: `${-indicatorOffset}px`,
          height: `${height}px`,
          width: '1px',
          pointerEvents: 'none',
        }}
      >
        <svg width={arrowSize * 2} height={height} style={{ position: 'absolute', left: `-${arrowSize}px`, top: '0' }}>
          {/* Hlavní čára po celé výšce */}
          <line x1={arrowSize} y1="0" x2={arrowSize} y2={height} stroke={lineColor} strokeWidth="1" />
          {/* Horní šipka */}
          <polyline points={`${arrowSize - arrowSize/2},${arrowSize} ${arrowSize},0 ${arrowSize + arrowSize/2},${arrowSize}`} stroke={lineColor} strokeWidth="1" fill="none" />
          {/* Dolní šipka */}
          <polyline points={`${arrowSize - arrowSize/2},${height - arrowSize} ${arrowSize},${height} ${arrowSize + arrowSize/2},${height - arrowSize}`} stroke={lineColor} strokeWidth="1" fill="none" />
        </svg>
        {/* Text vlevo od středu, otočený o 90° */}
        <span
          style={{
            position: 'absolute',
            top: '50%',
            left: `-${indicatorOffset + arrowSize * 2 + 5}px`, // Konzistentní prostor vlevo
            transform: 'translateY(-50%) rotate(-90deg)',
            transformOrigin: 'center',
            fontSize: `${fontSize}px`,
            fontFamily: 'monospace',
            color: textColor,
            whiteSpace: 'nowrap',
            fontWeight: 'bold',
            backgroundColor: 'rgba(255, 255, 255, 0.8)', // Bílé pozadí pro lepší čitelnost
            padding: '2px 4px',
            borderRadius: '2px',
          }}
        >
          {actualHeight}mm
        </span>
      </div>
    </>
  );
}
